<template>
  <loading
    v-if="isLoading"
    :active.sync="isLoading"
    :can-cancel="canCancel"
    :is-full-page="fullPage"
    :color="color"
    :width="width"
    :height="height"
  ></loading>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters } from 'vuex';

export default {
  components: {
    Loading,
  },
  props: {
    color: {
      default: '#ad932f',
      type: String,
    },
    width: {
      default: 100,
      type: Number,
    },
    height: {
      default: 100,
      type: Number,
    },
  },
  computed: {
    ...mapGetters('app', ['isLoading', 'canCancel', 'fullPage']),
  },
};
</script>

<style scoped></style>
